import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Component({
  selector: 'manage-member-roles',
  templateUrl: './manage-member-roles.component.html',
  styleUrls: ['./manage-member-roles.component.scss']
})
export class ManageMemberRolesComponent implements OnInit {

  public selMenu = 'roles';
  public roleList: Array<any> = [];
  public rolePermissionsList: Array<any> = [];
  public selected: any;
  public selectedPermissions: any = "";
  public formRoleName: string = '';
  public formRoleNameDescription: string = '';
  public formRolePermissionsName: string = '';
  public formRoleNamePermissionsDescription: string = '';
  public commonModal: any = null;

  /**
   * Constructor
   */
  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this._getAllRoleList();
    this._getAllRolePermissionsList();
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  public addRole(modal: any, selected: any = null) {
    if (selected) {
      this.formRoleName = selected?.roleName;
      this.formRoleNameDescription = selected?.description;
      this.selected = selected;
    } else {
      this.selected = null;
      this.formRoleNameDescription = this.formRoleName = '';
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public addRolePermissions(modal: any, selected: any = null) {
    if (selected) {
      this.formRolePermissionsName = selected?.roleName;
      this.formRoleNamePermissionsDescription = selected?.description;
      this.selected = selected;
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public deleteRole(id: any) {
    this.auth.deleteMemberRole(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllRoleList();
    }, ({ error }) => {
      this.toastr.error("Remove All Role Dependency!");
    })
  }

  public deleteMemberRolePermissions(id) {
    if (id) {
      this.auth.deleteMemberRolePermissions(id).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this._getAllRolePermissionsList();
      }, ({ error }) => {
        this.toastr.error("Permissions Already Assign To Role!");
      })
    } else {
      this.toastr.error("Select Permissions !");
    }
  }

  public deleteMemberRolePermissionsRelationship(id: any) {
    this.auth.deleteMemberRolePermissionsRelationship(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllRoleList();
    }, ({ error }) => {
      this.toastr.error(error.message);
    })
  }

  private _getAllRoleList() {
    this.auth.getAllMemberRole().subscribe((resp: ApiResponse) => {
      this.roleList = resp.body;
    })
  }

  private _getAllRolePermissionsList() {
    this.auth.getAllMemberRolePermissions().subscribe((resp: ApiResponse) => {
      this.rolePermissionsList = resp.body;
    })
  }

  public addMemberRolePermissionsRelationship(roleId, currentPermissionList) {
    if (this.selectedPermissions) {
      if (currentPermissionList.filter((i) => i.roleId == roleId && i.permissionsID == this.selectedPermissions).length > 0) {
        this.toastr.error("Role Already Present!");
      } else {
        this.auth.addMemberRolePermissionsRelationship({ roleId: roleId, permissionsID: this.selectedPermissions }).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this._getAllRoleList();
        });
      }
    } else {
      this.toastr.error("Select Permissions !");
    }
  }


  public AddRoleSubmit() {
    if (this.formRoleName) {
      let payload = {
        roleName: this.formRoleName.trim().toUpperCase(),
        description: this.formRoleNameDescription
      }
      if (this.selected) {
        payload['roleId'] = this.selected?.roleId;
      } else {
        if (this.roleList.filter((i: any) => i.roleName == payload['roleName']).length > 0) {
          this.toastr.error("Role Name Already Present!");
          return;
        }
      }

      this.auth.addMemberRole(payload).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this._getAllRoleList();
        this.formRoleNameDescription = this.formRoleName = '';
        this.selected = null;
      })
    }
  }

  public AddRolePermissionsSubmit() {
    if (this.formRolePermissionsName) {
      let payload = {
        permissionsName: this.formRolePermissionsName.trim().toUpperCase(),
        description: this.formRoleNamePermissionsDescription
      }
      if (this.selected) {
        payload['permissionsID'] = this.selected?.permissionsID;
      }

      this.auth.addMemberRolePermissions(payload).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        //this.commonModal.close();
        this._getAllRolePermissionsList();
        this.formRolePermissionsName = this.formRoleNamePermissionsDescription = '';
        this.selected = null;
      })
    }
  }

  public onPermissionChange(value) {
    this.selectedPermissions = value;
  }
}
